<template>
<v-container>

  <div class="text-center ma-2">

    <v-snackbar
      v-model="snackbar"
      top
    >
      {{ snackbarMsg }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>

  <v-data-table
    :headers="headers"
    :items="allTeam"
    sort-by="calories"
    class="elevation-1"
    :item-key="dataKey"
    :loading="loadingTable"
    loading-text="Carregando dados..."
    :fixed-header="true"
    
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Equipe</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              fab
              color="blue-grey darken-3"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            ><v-icon>mdi-plus</v-icon></v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
                <v-form 
                    ref="form"
                    v-model="valid"
                >                
                <v-container>
                    <v-row>
                    <v-col cols="12">
                        <v-text-field :value="editedItem.id" @change="v => editedItem.id = v"
                        prepend-icon="mdi-email" autocomplete="true" :disabled="editedIndex === -1 ? false : true" required :rules="editedIndex === -1 ? emailRules.concat(idExist) : []" label="E-mail"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field :value="editedItem.name" @change="v => editedItem.name = v"
                        prepend-icon="mdi-account" required :rules="nameRules" label="Nome"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field :value="editedItem.shortName" @change="v => editedItem.shortName = v"
                        prepend-icon="mdi-account" required  label="Nome Curto"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field :value="editedItem.modulo" @change="v => editedItem.modulo = v"
                        prepend-icon="mdi-laptop" required :rules="moduloRules" label="Modulo"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field :value="editedItem.phone" @change="v => editedItem.phone = v"
                        prepend-icon="mdi-cellphone" required :rules="phoneRules" label="Celular" 
                        inputmode="decimal" pattern="[0-9]*" type="number"
                          
                        ></v-text-field>
                    </v-col>
                    </v-row>
                </v-container>
                </v-form>              
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="error"  
                      @click="close"
                      :disabled="loading"
              >
              Cancelar
              </v-btn>
              <v-btn small dark color="blue-grey darken-1"  
                     @click="save"
                     :loading="loading"
                     :disabled="loading"
              >
              Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>


        <v-dialog 
           v-model="dialogExclusao"
           persistent 
           max-width="290"
           :retain-focus="false"
           >
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              
              @click="confirmDelete(item)"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
          </template>        
          <v-card>
            <v-card-title class="headline">Confirma a Exclusão?</v-card-title>
            <v-card-text>
               O item <span class="font-weight-black"> {{deleteId}} </span>  
               
                será excluido.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="dialogExclusao = false">NÃO</v-btn>
              <v-btn color="green darken-1" text @click="deleteItem()">SIM</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </template>

    <template v-slot:item.id="{ item }" >
      <span class="font-weight-black">
        {{ item.id }}
      </span>
      
    </template>
    <template v-slot:no-data>
      <!-- <v-btn color="primary">Reset</v-btn> -->
    </template>
  </v-data-table>

</v-container>  
</template>

<script>
  import { mapGetters } from 'vuex';
  
  import fb from '@/firebaseConfig'

  const viewCollection = fb.teamCollection;
  
  

  export default {
    data: () => ({
      dataKey: 'id',
      dialog: false,
      dialogExclusao: false,
      valid: false,
      snackbar: false,
      snackbarMsg: '',
      loading: false,
      loadingTable: false,
      
      
      headers: [
        { text: 'E-mail', value: 'id', align:'start', class:'font-weight-black'},
        { text: 'Nome Completo', value: 'name'},
        { text: 'Nome Curto', value: 'shortName'},
        { text: 'Modulo', value: 'modulo' },
        { text: 'Celular', value: 'phone' },
        { text: '', value: 'actions', sortable: false }
      ],
      editedIndex: -1,
      editedItem: {
        name: '',
        shortName: '',
        modulo: '',
        phone: '',
      },
      deleteId: '',
      
      defaultItem: {
        name: '',
        shortName: '',
        modulo: '',
        phone: '',
      },
      emailRules: [ v => !!v || 'E-mail é obrigatório', 
                    v => /.+@.+/.test(v) || 'e-mail inválido'
                    
      ],
      nameRules: [ v => !!v || 'Nome é obrigatório'],
      moduloRules: [ v => !!v || 'Modulo é obrigatório'],
      phoneRules: [ v => !!v || 'Celular é obrigatório']
    }),

    computed: {
      ...mapGetters(['allTeam']),
      
      formTitle () {
        return this.editedIndex === -1 ? 'Novo' : 'Editar'
      },

      idExist () {
        return [this.allTeam.find( item => item[this.dataKey] === this.editedItem[this.dataKey]) ? 'e-mail existente' : true]
      }

    },

    watch: {
      dialog (val) {
        val || this.close()
      }

    },



    methods: {

      

      editItem (item) {
        this.editedIndex = this.allTeam.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      confirmDelete (item){
        const index = this.allTeam.indexOf(item)
        this.deleteId = this.allTeam[index][this.dataKey];
        // this.dialogExclusao = true;
      },

      deleteItem () {
        
        
        viewCollection.doc(this.deleteId).delete()
        .then(this.snackbarMsg = 'registro excluido com sucesso')
        .then(this.snackbar = true)
        .catch(function(error) {
            console.error("Error removing document: ", error );
        });

        this.dialogExclusao = false;
        this.deleteId = '';
        
        
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
        this.$refs.form.resetValidation();
      },

      save () {

          if (this.$refs.form.validate()) {
            this.loading = true;

            viewCollection.doc(this.editedItem[this.dataKey]).set(this.editedItem)
            .then(function() {
                console.log("Document successfully written!");
            })
            .then(this.snackbarMsg = 'registro incluido com sucesso')
            .then(this.snackbar = true)
            .catch(function(error) {
                console.error("Error writing document: ", error);
            });            

            this.loading = false;
            this.close();

          }
      },


    },
  }
</script>

<style scoped>


</style>